import { render, staticRenderFns } from "./segmentosConfiguracoesEditar.vue?vue&type=template&id=c216aa6e&scoped=true&"
import script from "./segmentosConfiguracoesEditar.vue?vue&type=script&lang=js&"
export * from "./segmentosConfiguracoesEditar.vue?vue&type=script&lang=js&"
import style0 from "./segmentosConfiguracoesEditar.vue?vue&type=style&index=0&id=c216aa6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c216aa6e",
  null
  
)

export default component.exports